import { FACILITY_USER_ACCESS_MODE } from '@/constants/facilityUserAccessModes';

const toInteger = (value) => parseInt(value, 10);

const buildFacilityPermissionsArrayFromUser = (user) => {
  const facilityPermissionsArray = [];

  user.facility_and_permissions?.forEach((fp) => {
    if (fp.permissions && Object.keys(fp.permissions).length > 0) {
      facilityPermissionsArray.push({
        facilityId: fp.facilityId,
        permissions: fp.permissions,
      });
    }
  });

  return facilityPermissionsArray;
};

const buildFacilityPermissionsArray = (facilityPermissions) => {
  const facilityPermissionsArray = [];

  Object.entries(facilityPermissions).forEach(([facilityId, permissions]) => {
    if (
      !isNaN(facilityId) &&
      permissions &&
      Object.keys(permissions).length > 0
    ) {
      facilityPermissionsArray.push({
        facilityId: toInteger(facilityId),
        permissions,
      });
    }
  });

  return facilityPermissionsArray;
};

const addOrganizationPermissions = (formData, organizationPermissions) => {
  Object.entries(organizationPermissions).forEach(([orgId, permissions]) => {
    if (!isNaN(orgId) && permissions && Object.keys(permissions).length > 0) {
      formData.organization_permissions = permissions;
    }
  });
};

export const buildBasicInfoFormData = ({
  basicInfo,
  permissionsType,
  selectedRoleId,
  accessMode,
  selectedFacilities,
  selectedOrganization,
  user,
}) => {
  if (permissionsType === 'role') {
    return {
      email: basicInfo.email,
      name: basicInfo.userName || basicInfo.name,
      mfa_type: basicInfo.mfa_type,
      language_preference: basicInfo.languagePreference,
      permissions_type: permissionsType,
      role_id: selectedRoleId,
    };
  }

  const formData = {
    email: basicInfo.email,
    name: basicInfo.userName || basicInfo.name,
    mfa_type: basicInfo.mfa_type,
    language_preference: basicInfo.languagePreference,
    has_all_facilities_access:
      accessMode === FACILITY_USER_ACCESS_MODE.ALL_FACILITIES,
    facility_ids:
      accessMode === FACILITY_USER_ACCESS_MODE.DIRECT_FACILITIES
        ? selectedFacilities.map(toInteger)
        : [],
    organization_id: selectedOrganization
      ? toInteger(selectedOrganization)
      : null,
    permissions_type: permissionsType,
  };

  const facilityPermissionsArray = buildFacilityPermissionsArrayFromUser(user);

  if (facilityPermissionsArray.length > 0) {
    formData.facility_permissions = facilityPermissionsArray;
  }

  if (user.organization_permissions?.permissions) {
    formData.organization_permissions =
      user.organization_permissions.permissions;
  }

  return formData;
};

export const buildPermissionsFormData = ({
  user,
  permissionsType,
  selectedRoleId,
  selectedFacilities,
  selectedOrganization,
  facilityPermissions,
  organizationPermissions,
}) => {
  const formData = {
    email: user.user_data.email,
    name: user.user_data.name,
    mfa_type: user.user_data.mfa_type,
    language_preference: user.user_data.language_preference,
    facility_ids: selectedFacilities.map(toInteger),
    organization_id: selectedOrganization
      ? toInteger(selectedOrganization)
      : null,
    permissions_type: permissionsType,
  };

  if (permissionsType === 'role') {
    formData.role_id = selectedRoleId;
    return formData;
  }

  const facilityPermissionsArray = buildFacilityPermissionsArray(
    facilityPermissions,
  );

  if (facilityPermissionsArray.length > 0) {
    formData.facility_permissions = facilityPermissionsArray;
  }

  addOrganizationPermissions(formData, organizationPermissions);

  return formData;
};

export const buildEmployeeInfoFormData = (employeeInfo) => ({
  first_name: employeeInfo.first_name,
  last_name: employeeInfo.last_name,
  employee_number: employeeInfo.employee_number,
  management_level: employeeInfo.management_level,
  approval_limit: employeeInfo.approval_limit,
  job_code: employeeInfo.job_code,
  job_title: employeeInfo.job_title,
  department: employeeInfo.department,
});

export const wasFacilityGroupScoped = (user) =>
  user?.user_data?.access_mode === FACILITY_USER_ACCESS_MODE.FACILITY_GROUPS ||
  (user?.assigned_facility_groups || []).length > 0;
